import { Gender, GenderLabel } from '@idc-forms/types/gender'

export { Gender, GenderLabel }

// FE-only: country API mapping
export const TypeGenderCountries = {
  M: 'male',
  F: 'female'
} as const

// FE-only: array para <select>
export const CATALOG_GENDER = [
  { value: Gender.MALE, label: GenderLabel[Gender.MALE] },
  { value: Gender.FEMALE, label: GenderLabel[Gender.FEMALE] }
]

// Aliases temporales — borrar cuando se actualicen los consumers
export const EnumGender = Gender
export type EnumGender = Gender
export const TYPE_GENDER = Gender
export const NAME_TYPE_GENDER = GenderLabel
export type TypesGender = Gender
